import React, { useState } from 'react';
import TextField from "@material-ui/core/TextField";
import TeamSettings from './TeamSettings';
import { useDeleteUserGroups } from '../../hooks/useDeleteUserGroupsTeam';
import Swal from 'sweetalert2';

const Team = ({ item, index, userGroupId }) => {
  const [openSettings, setOpenSettings] = useState(false);
  const deleteTeamMutation = useDeleteUserGroups();

  const handleEditClick = () => {
    setOpenSettings(true);
  };

  const handleCloseSettings = () => {
    setOpenSettings(false);
  };

  const handleDeleteClick = (e) => {
    e.preventDefault();
    if (window.confirm('Are you sure you wish to delete this item?')) {
      deleteTeamMutation.mutate(item._id, {
        onSuccess: () => {
          Swal.fire({
            type: 'success',
            title: 'Team deleted successfully',
            showConfirmButton: false,
            timer: 1500
          });
        },
        onError: (error) => {
          Swal.fire({
            type: 'error',
            title: 'Error deleting team',
            text: error.message || 'An error occurred while deleting the team',
            showConfirmButton: true
          });
        }
      });
    }
  };

  return (
    <React.Fragment>
      <div className="input-group-prepend">
        <span className="input-group-text">
          <i className="material-icons">people</i>
        </span>
      </div>
      <div className="form-group bmd-form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {/* <label>Teams: </label> */}
        <TextField
          disabled
          label="Team name"
          name={`team-${index}`}
          value={item.title}
          margin="normal"
          style={{ flex: 1 }}
        />
        <i className="material-icons" style={{ cursor: 'pointer' }} onClick={handleEditClick}>edit</i>
        <i className="material-icons" style={{ cursor: 'pointer' }} onClick={handleDeleteClick}>delete</i>
      </div>
      
      <TeamSettings 
        open={openSettings} 
        handleClose={handleCloseSettings}
        teamData={item}
        userGroupId={userGroupId}
      />
    </React.Fragment>
  );
};

export default Team;
